import React from 'react'
import { Message } from 'semantic-ui-react'

const WarningMessage = (props) => (
  <Message compact negative>
    {props.header ? <Message.Header>{props.header}</Message.Header> : <span style={{display: "none"}}/>}
    <span>{props.message}</span>
  </Message>
)

export default WarningMessage